import api from './api';

const categoriaAdminService = {
  listar: async () => {
    const { data } = await api.get('/categorias');
    return data.data;
  },

  crear: async (categoria) => {
    const { data } = await api.post('/categorias', categoria);
    return data.data;
  },

  actualizar: async (id, categoria) => {
    const { data } = await api.put(`/categorias/${id}`, categoria);
    return data.data;
  },

  desactivar: async (id) => {
    await api.delete(`/categorias/${id}`);
  },
};

export default categoriaAdminService;